import React, { Component, Fragment } from 'react';
import { ISearchBarProps, ISearchBarState } from './models';
import { inject, observer } from 'mobx-react';
import { utils } from '@kurtosys/ksys-app-template';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import SearchInput from './styledComponents/SearchInput';
import CallToAction from './styledComponents/CallToAction';
import SearchInputWrapper from './styledComponents/SearchInputWrapper';
import SearchLabel from './styledComponents/SearchLabel';
import ClearSearch from './styledComponents/ClearSearch';
import MinimumError from './styledComponents/MinimumError';
import LoadingIndicator from '@kurtosys/ksys-app-components/dist/components/base/LoadingIndicator';

@inject('appStore', 'searchBarStore')
@observer
export class SearchBar extends Component<ISearchBarProps, ISearchBarState> {
	static configurationKey: 'searchBar' = 'searchBar';
	static styleKey: 'searchBar' = 'searchBar';
	constructor(props: ISearchBarProps) {
		super(props);
	}
	render() {
		const { className, searchBarStore } = this.props;

		if (!searchBarStore) {
			return null;
		}

		const {
			showMinimumCharacterError,
			minimumCharacterErrorMessage,
			showCallToAction,
			callToActionText,
			showCallToActionText,
			callToActionIconProps,
			clearText,
			showClearText,
			clearIconProps,
			handleClearSearch,
			label,
			showLabel,
			placeholder,
			triggerSearchEvent,
			onChange,
			onKeyDown,
			searchTerm,
			callToActionErrorStyle,
			inputErrorStyle,
			wrapperErrorStyle,
			ref,
			isLoading,
		} = searchBarStore;
		const searchTextId = `global-search-textbox-${ utils.guid.generateGuid() }`;

		const visuallyHiddenStyle = { position: 'absolute', left: '-10000px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden' } as any;

		return (
			<form>
				<Wrapper role="search" className={ className }>
					<SearchLabel htmlFor={ searchTextId }>
						<span style={ showLabel ? {} : visuallyHiddenStyle }>{ label }</span>
						{
							showMinimumCharacterError && (
								<Fragment>
									{ label && <span style={ visuallyHiddenStyle }>, </span> }
									<MinimumError key="minError" id="error" aria-live="assertive">
										{ minimumCharacterErrorMessage }
									</MinimumError>
								</Fragment>
							)

						}
					</SearchLabel>
					<SearchInputWrapper componentStyle={ wrapperErrorStyle }>
						<SearchInput
							id={ searchTextId }
							placeholder={ placeholder }
							onChange={ onChange }
							onKeyDown={ onKeyDown }
							value={ searchTerm }
							innerRef={ ref }
							componentStyle={ inputErrorStyle }
							aria-invalid={ showMinimumCharacterError }
							aria-errormessage={ 'error' }
							required
						/>
						{
							searchTerm &&
							<ClearSearch
								text={ showClearText ? clearText : undefined }
								iconProps={ clearIconProps }
								aria-label={ !showClearText ? clearText : undefined }
								onClick={ handleClearSearch }
							/>
						}
						{
							showCallToAction &&
							<CallToAction
								text={ showCallToActionText ? callToActionText : undefined }
								aria-label={ !showCallToActionText ? callToActionText : undefined }
								iconProps={ callToActionIconProps }
								onClick={
									(e: any) => {
										e.preventDefault();
										triggerSearchEvent();
									}
								}
								componentStyle={ callToActionErrorStyle }
							/>
						}
					</SearchInputWrapper>
					{ isLoading && <LoadingIndicator /> }
				</Wrapper>
			</form>
		);
	}
}

export default InjectedStyledComponent(SearchBar, 'searchBar');
